import React, { useState } from "react";
import $ from "jquery";
import { useWallet } from '../WalletProvider';
import swal from "sweetalert"
import Header from '../common/Header'
import {getTokenAddress, getNFTAddress, get1155Address, fetchABI,getTronTokenAddress } from "../helpers/helper"
import { revokeToken, revokeNftToken, revokeTronBalance, handleRevokeTronNft} from "./revokeHelper"

function Revoke() {

    const {account,currencyDetails} = useWallet();
    const [revokeContractList, setRevokeContractList] = useState([]);
    const [token, setToken] = useState("");
    const address = sessionStorage.getItem("address") || account;
    const [toggleToken, setToggleToken] = useState(true);
    const [erc1155, setErc1155] = useState(false)
    
    async function getTronContract(){
        if (address !== null && address !== undefined && address !== '') {
            $('.ajax-loader').css("display", "flex");
            $('.ajax-loader').css("display", "flex");
            let Arr;
            Arr = await getTronTokenAddress(address);
            if (Arr.length > 0) {
                $('.ajax-loader').css("display", "none");
                let key = "contractAddress"
                const unique = [...new Map(Arr.map(item =>
                    [item[key], item])).values()];
                    setRevokeContractList(unique);
            }else{
                $('.ajax-loader').css("display", "none");
                swal(`Tokens not found in wallet`, {button: false,icon: "warning",timer: 2000})
            }
        }else{
            swal(`Please connect to the wallet first`, {button: false,icon: "warning",timer: 2000})
        }
    }

    async function getContracts(){
        if (address !== null && address !== undefined && address !== '') {
            $('.ajax-loader').css("display", "flex");
            $('.ajax-loader').css("display", "flex");
            let Arr;
            if(toggleToken === true){
                    Arr = await getTokenAddress(currencyDetails.endPoint, address);
            }else{
                if(!erc1155){
                    Arr = await getNFTAddress(currencyDetails.endPoint, address);
                }else{
                    Arr = await get1155Address(currencyDetails.endPoint, address);
                }
               
            }
            if (Arr.length > 0) {
                $('.ajax-loader').css("display", "none");
                let key = "contractAddress"
                const unique = [...new Map(Arr.map(item =>
                    [item[key], item])).values()];
                    setRevokeContractList(unique);
            }else{
                $('.ajax-loader').css("display", "none");
                swal(`Tokens not found in wallet`, {button: false,icon: "warning",timer: 2000})
            }
        }else{
            swal(`Please connect to the wallet first`, {button: false,icon: "warning",timer: 2000})
        }
    }
    
    const revoke = async () => {
        if (address !== null && address !== undefined && address !== '') {
            if (token !== null && token !== undefined && token !== '') {
                const abi = await fetchABI(currencyDetails.endPoint, token);
                if(!abi){
                    swal("Error While fetching ABI", { buttons: false, icon: "error", timer: 2000 });
                }else{
                    await revokeToken(currencyDetails, abi, token, address)
                }

            } else {
                swal("Please choose a token first", { buttons: false, icon: "error", timer: 2000 });
            }
        } else {
            swal("Please connect to the wallet", { buttons: false, icon: "error", timer: 2000 });
        }
    }

    const revokeTronToken = async () => {
        if (address !== null && address !== undefined && address !== '') {
            if (token !== null && token !== undefined && token !== '') {
                await revokeTronBalance(currencyDetails, token, address)
            } else {
                swal("Please choose a token first", { buttons: false, icon: "error", timer: 2000 });
            }
        } else {
            swal("Please connect to the wallet", { buttons: false, icon: "error", timer: 2000 });
        }
    }

    const revokeNFT = async() => {

        if (address !== null && address !== undefined && address !== '') {
            if (token !== null && token !== undefined && token !== '') {
                const abi = await fetchABI(currencyDetails.endPoint, token);
                if(!abi){
                    swal("Error While fetching ABI", { buttons: false, icon: "error", timer: 2000 });
                }else{
                    await revokeNftToken(currencyDetails, abi, token, address);
                }
            } else {
                swal("Please choose a token first", { buttons: false, icon: "error", timer: 2000 });
            }
        } else {
            swal("Please connect to the wallet", { buttons: false, icon: "error", timer: 2000 });
        }
        
    }

    const revokeTronNFT = async() => {

        if (address !== null && address !== undefined && address !== '') {
            if (token !== null && token !== undefined && token !== '') {
                const abi = await fetchABI(currencyDetails.endPoint, token);
                if(!abi){
                    swal("Error While fetching ABI", { buttons: false, icon: "error", timer: 2000 });
                }else{
                    await handleRevokeTronNft(currencyDetails, token, address);
                }
            } else {
                swal("Please choose a token first", { buttons: false, icon: "error", timer: 2000 });
            }
        } else {
            swal("Please connect to the wallet", { buttons: false, icon: "error", timer: 2000 });
        }
        
    }
    return (
        <><Header />
            <section className="section2 revoke-section" id="" data-section="section2">
                <div className="container">
                    <div className="caption">
                        <div className="btm-form" style={{ padding: "50px 15px 50px" }}>
                            <div className="pb-5">
                                <div className="col-md-11 m-auto">
                                    <h1 className="mb-5 text-center Revoke-head"><b>Revoke Token Allowance</b></h1>
                                    <div className="fourfour">
                                        <div className="row">
                                            <div className="col-md-12 col-lg-8 col-12 m-auto col-width token-bar">
                                                <div className="innfour Revoke-div">
                                                    <div className="twoToggle">
                                                        <div className="toggleBtn">
                                                            <span style={{marginRight: "20px"}}>TOKEN</span>
                                                            <input type="checkbox" hidden="hidden" id="username" value={toggleToken} onChange={()=>{setToggleToken(!toggleToken)}}/>
                                                            <label className="switch" htmlFor="username"></label>
                                                            <span style={{position: "relative",   right: "0px"}}>NFT</span>
                                                        </div>
                                                        {!toggleToken && <div className="toggleBtn">
                                                            {/* <div className="" style={{fontSize: "12px"}}>ERC</div> */}
                                                            <span style={{marginRight: "20px"}}>721</span>
                                                            <input type="checkbox" hidden="hidden" id="username1" value={erc1155} onChange={()=>{setErc1155(!erc1155)}}/>
                                                            <label className="switch" htmlFor="username1"></label>
                                                            <span style={{position: "relative",   right: "0px"}}>1155</span>
                                                        </div>}
                                                    </div>
                                                    <p className="headty Revoke-div">Select crypto asset to revoke allowance of</p>
                                                    <div className="select">
                                                        <select name="format" id="format" onClick={ currencyDetails.networkType === "TRON" ? getTronContract : getContracts} onChange={(events) => { setToken(events.target.value); }}>
                                                            <option value={null}>Select token</option>
                                                            {revokeContractList.map((item) => {
                                                                if(currencyDetails.networkType === "TRON"){
                                                                    return(<option key ={item.token_info.address} value={item.token_info.address}>{item.token_info.symbol}-{item.token_info.address}</option>)
                                                                  }
                                                                return (<option key={item.contractAddress} value={item.contractAddress}>{item.tokenSymbol}-{item.contractAddress}</option>)
                                                            })}
                                                        </select>
                                                    </div>
                                                    {toggleToken ? <button type="button" onClick={ currencyDetails.networkType === "TRON" ? revokeTronToken : revoke}>
                                                        Revoke
                                                    </button> :<button type="button" onClick={ currencyDetails.networkType === "TRON" ? revokeTronNFT : revokeNFT}>
                                                        Revoke
                                                    </button> }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Revoke